import { render, staticRenderFns } from "./giftList.vue?vue&type=template&id=300db495&"
import script from "./giftList.vue?vue&type=script&lang=js&"
export * from "./giftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports